module.exports = __webpack_public_path__ + "img/bg-ketqua.7094be43.jpg";